import useOnboardingNavigation from './useOnboardingNavigation'

export default useOnboardingNavigation
